export const CJ_LOADER_NAME = "consulting-journey-loader";
export const EXC_LOADER_NAME = "express-checkout-loader";
export const CREDITIVA_LOADER_NAME = "creditiva-loader";

export const EC_SESSION_KEY = "ec-session-state";

export const EXPIRATION_TIME_MS = 4000;

export type FallbackReason =
	| "api_error"
	| "no_debts"
	| "only_leads"
	| "timeout";

export type CreditBlockPosition = "above" | "below";

export type TrackingStatus = {
	started?: boolean;
	completed?: boolean;
};

export interface ECSessionState {
	hasLoaded: boolean;
	hasTimedOut: boolean;
	tracking: TrackingStatus;
	creditBlockPosition?: CreditBlockPosition;
}
